import {Component, OnDestroy, OnInit} from '@angular/core';
import {Subscription} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';

@Component({
  selector: 'app-siparis-olusturuldu',
  templateUrl: './siparis-olusturuldu.component.html',
  styleUrls: ['./siparis-olusturuldu.component.css']
})
export class SiparisOlusturulduComponent implements OnInit, OnDestroy {
  private subscriptions: Subscription[] = [];
  talepId: string = null;

  constructor(private route: ActivatedRoute,
              private router: Router) {
  }

  ngOnInit(): void {
    this.subscriptions.push(this.route.queryParams.subscribe(params => {
      // console.log(params);
      this.talepId = params.id;
    }));
  }


  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s.unsubscribe());
  }


  showDetails() {
    this.router.navigate(['siparis'], {queryParams: {id: this.talepId}});

  }

  showSiparisler() {
    this.router.navigate(['siparisler']);
  }
}
